/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

const reset_selected_swatches = (swatchList) => {
    swatchList.forEach( (swatch) => {
        swatch.classList.remove("color-swatch--selected");
    } )
}

const update_swatch_img = () => {
    let cards = document.querySelectorAll(".Grid__Cell .ProductItem");
    if(cards.length > 0 ){
        cards.forEach( (card) => {
          let img_swatches = card.querySelectorAll(".color-options a");
          img_swatches.forEach( (swatch) => {
            let img_url = swatch.querySelector("img").getAttribute("data-feat-img");
            let img_url_alt = swatch.querySelector("img").getAttribute("data-feat-img-alt");
            let pre_load = new Image().src = img_url;
            swatch.addEventListener("click", (e) => {
              e.preventDefault();
              reset_selected_swatches(img_swatches);
              let card_img = card.querySelector("img.ProductItem__Image");
              card_img.srcset = "";
              card_img.src = img_url;
              card_img.setAttribute("data-current-src", img_url);
              card_img.setAttribute("data-alt-img-hover", img_url_alt )
              swatch.classList.add("color-swatch--selected");
              add_image_hover(card);
            });
          } );
        } );
    }
};
update_swatch_img();

const add_image_hover = (single=false) => {
  let prod_cards = document.querySelectorAll(".Grid__Cell .ProductItem");
  if( !prod_cards ){
    console.log("!! no cards");
    return;
  }

  if( !single ) {
    prod_cards.forEach( (card) => {
      let card_img = card.querySelector("img.ProductItem__Image");
      let current_img = card_img.getAttribute("data-current-src");
      let alt_src = card_img.getAttribute("data-alt-img-hover");
      let pre_load = new Image().src = alt_src;

      card_img.addEventListener("mouseenter", (e) => {
        alt_src = card_img.getAttribute("data-alt-img-hover");
        card_img.srcset = "";
        card_img.src = alt_src;
      });
      card_img.addEventListener("mouseleave", (e) => {
        current_img = card_img.getAttribute("data-current-src");
        card_img.src = current_img;
      });
    } );
  } else {
    let card_img = single.querySelector("img.ProductItem__Image");
    let current_img = card_img.getAttribute("data-current-src");
    let alt_src = card_img.getAttribute("data-alt-img-hover");
    let pre_load = new Image().src = alt_src;

    card_img.addEventListener("mouseenter", (e) => {
      alt_src = card_img.getAttribute("data-alt-img-hover");
      card_img.srcset = "";
      card_img.src = alt_src;
    });
    card_img.addEventListener("mouseleave", (e) => {
      current_img = card_img.getAttribute("data-current-src");
      card_img.src = current_img;
    });
  }
}
add_image_hover();

window.quickAddToCart = async function(variantID, qty = 1) {
  if(!variantID) return;
  try {
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    const url = `${window.Shopify.routes.root}cart/add.js`;
    const data = {
      items: [
        {
          id: variantID,
          quantity: qty
        }
      ]
    }
    const config = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      credentials: 'same-origin',
      body: JSON.stringify(data),
    }

    const response = await fetch(url, config);
    const result = await response.json();
    document.dispatchEvent(new CustomEvent('theme:loading:end'));

    if(response.ok) {
      document.dispatchEvent(new CustomEvent('product:added', {
        bubbles: true,
        detail: {
          variant: variantID,
          quantity: qty
        }
      }));
    } else {
      console.error(result.message)
    }
  } catch (error) {
    console.error(err);
  }
};